import { FormStepId } from 'shared/config/formStepId';
import { useAppSelector } from 'shared/lib/redux';

import { useGetEssentialCreditStatusQuery } from 'entities/essentialCreditStatus';
import { isLoggedSelector } from 'entities/user';

import { getShouldShowEsiaConsentBanner } from './getShouldShowEsiaConsentBanner';

export const useShouldShowEsiaConsentBanner = (formId: ValuesOf<typeof FormStepId>) => {
  const isAuth = useAppSelector(isLoggedSelector);
  const { data, isError, isSuccess, isLoading, isFetching } = useGetEssentialCreditStatusQuery(undefined, {
    skip: !isAuth,
  });

  const shouldShow =
    formId === FormStepId.PassportInfo &&
    !isLoading &&
    !isFetching &&
    getShouldShowEsiaConsentBanner({ isError, isSuccess, data });

  return shouldShow;
};
